import React from 'react';
import { Table, Button } from 'react-bootstrap';

const SempDayList = ({ days, onEdit, onDelete }) => {
    return (
        <Table striped bordered hover responsive="sm">
            <thead>
                <tr>
                    <th>#</th>
                    <th>연도</th>
                    <th>날짜</th>
                    <th>요일 제목</th>
                    <th>주제</th>
                    <th>유튜브 링크</th>
                    <th>관리</th>
                </tr>
            </thead>
            <tbody>
                {days.length > 0 ? (
                    days.map(day => (
                        <tr key={day.semp_seq_no}>
                            <td>{day.semp_seq_no}</td>
                            <td>{day.semp_year}</td>
                            <td>{day.semp_date}</td>
                            <td>{day.semp_daytitle}</td>
                            <td>{day.semp_subject}</td>
                            <td>
                                {day.semp_youtube && 
                                    <a href={day.semp_youtube} target="_blank" rel="noopener noreferrer">링크</a>
                                }
                            </td>
                            <td>
                                <Button variant="outline-secondary" size="sm" onClick={() => onEdit(day)} className="me-2">
                                    수정
                                </Button>
                                <Button variant="outline-danger" size="sm" onClick={() => onDelete(day.semp_seq_no)}>
                                    삭제
                                </Button>
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="7" className="text-center">데이터가 없습니다.</td>
                    </tr>
                )}
            </tbody>
        </Table>
    );
};

export default SempDayList;
